import { Box, Stack, Typography } from '@mui/material';

import { radius } from '@karehero/llama/theme/radius';

import StatusBar from '@/designs-dev/device/StatusBar';
import HomeIndicator from '@/designs-dev/device/HomeIndicator';
import ScreenRoot from '@/components/wrapped/ScreenRoot';
import { SELF_BRANCH } from '@/karehero-app/tell-us-once/intake/content';

// Where the self branch stops being drawn. The rest of it is the same chat with
// the wording turned around, so drawing every screen twice would say nothing the
// first four already say.
//
// No onward action: this is the end of the branch on the flows page, not a step
// in a journey.
const SelfBranchScreen = () => (
  <ScreenRoot sx={{ bgcolor: 'custom.neutral.300' }}>
    <StatusBar />

    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 3,
      }}
    >
      <Stack
        sx={{
          width: '100%',
          p: 3,
          textAlign: 'center',
          border: 1,
          borderStyle: 'dashed',
          borderColor: 'custom.neutral.500',
          borderRadius: `${radius.md}px`,
        }}
        spacing={1}
      >
        <Typography sx={{ color: 'text.secondary' }} variant='overline'>
          Placeholder
        </Typography>
        <Typography variant='h2'>{SELF_BRANCH.title}</Typography>
        <Typography sx={{ color: 'text.secondary' }} variant='body2'>
          {SELF_BRANCH.note}
        </Typography>
      </Stack>
    </Box>

    <HomeIndicator />
  </ScreenRoot>
);

export default SelfBranchScreen;
